import React from "react";
import { useTranslation } from "react-i18next";

interface StepBreadcrumbsProps {
  currentStep: number;
}

const StepBreadcrumbs: React.FC<StepBreadcrumbsProps> = ({ currentStep }) => {
  const { t } = useTranslation();
  const steps = [
    { id: 1, label: t("step.service")   },
    { id: 2, label: t("step.contact")},
  ];
  

  return (
    <div className="flex items-center space-x-8 mb-2 lg:mb-6">
      {steps.map((step, index) => (
        <React.Fragment key={step.id}>
          <div className="flex items-center space-x-2 lg:space-x-4">
            <div
              className={`rounded-full w-8 h-8 text-[12px] lg:text-[12px] flex items-center justify-center text-sm font-semibold ${
                currentStep === step.id
                  ? "bg-bgPrimary text-white"
                  : "bg-gray-200 text-gray-950"
              }`}
            >
              {step.id}
            </div>
            <span
              className={`${
                currentStep === step.id
                  ? "text-gray-950  font-semibold text-[12px] lg:text-[12px]"
                  : "text-gray-950 text-[12px] lg:text-[12px]"
              }`}
            >
              {step.label}
            </span>
          </div>
          {index < steps.length - 1 && (
            <span className="text-textTitle text-[20px] lg:text-[24px]">{">"}</span>
          )}
        </React.Fragment>
      ))}
      
    </div>
  );
};

export default StepBreadcrumbs;
